import {
  Discord,
  FlexGrid,
  FlexGridItem,
  LabelSmall,
  XTwitter,
} from "@mezo-org/mezo-clay"
import { Link } from "@tanstack/react-router"

import { links } from "#/shared/constants"

export default function SidebarNavigationHelp() {
  return (
    <FlexGrid
      flexGridColumnCount={3}
      marginTop="40px"
      gridColumnGap="16px"
      alignItems="center"
    >
      <FlexGridItem>
        <Link to={links.DISCORD_SUPPORT} target="_blank">
          <LabelSmall>Need help?</LabelSmall>
        </Link>
      </FlexGridItem>
      <FlexGridItem
        data-attr="sidebar-twitter"
        as="a"
        maxWidth="20px"
        href={links.X}
        target="_blank"
        height="20px"
      >
        <XTwitter size={20} color="contentSecondary" />
      </FlexGridItem>
      <FlexGridItem
        data-attr="sidebar-discord"
        as="a"
        maxWidth="20px"
        href={links.DISCORD}
        target="_blank"
        height="20px"
      >
        <Discord size={20} color="contentSecondary" />
      </FlexGridItem>
    </FlexGrid>
  )
}
